import axiosClient from "./axiosClient";

export async function submitPartnerRequest(payload) {
  const response = await axiosClient.post("/partner-requests", payload);
  return response.data;
}
